import { combineReducers } from "redux";

import list from "./list/reducer";
import details from "./details/reducer";
import manufacturers from "./manufacturers";

export * from "./actions";
export * from "./selectors";
export * from "./manufacturers";

export default combineReducers({ list, details, manufacturers });
